/**
 * 普通登录表单 schema
 *
 * @param isPreview - 是否是预览
 * @returns 表单字段
 */
export const useNormalSchema = (isPreview?: boolean) => {
  const normalSchema = {
    type: 'object',
    properties: {
      account: {
        type: 'string',
        required: !isPreview,
        'x-decorator': 'FormItem',
        'x-component': 'Input',
        'x-component-props': {
          placeholder: '请输入账号',
        },
      },
      password: {
        type: 'string',
        required: !isPreview,
        'x-decorator': 'FormItem',
        'x-component': 'Password',
        'x-decorator-props': {
          style: { marginBottom: 9 },
        },
        'x-component-props': {
          placeholder: '请输入密码',
        },
      },
    },
  }
  return normalSchema
}

/**
 * 手机号登录表单
 *
 * @param isPreview - 是否是预览
 * @returns 表单字段
 */
export const usePhoneSchema = (isPreview?: boolean) => {
  const phoneSchema = {
    type: 'object',
    properties: {
      phone: {
        type: 'string',
        required: !isPreview,
        'x-decorator': 'FormItem',
        'x-component': 'Input',
        'x-component-props': {
          placeholder: '请输入手机号码',
        },
        'x-validator': (value: string) => {
          const reg = /^[1][3,4,5,6.7,8,9][0-9]{9}$/
          if (!reg.test(value) && !isPreview) {
            return {
              type: 'error',
              message: '请输入正确手机号',
            }
          }
        },
      },
      reminderId: {
        type: 'string',
        required: !isPreview,
        'x-decorator': 'FormItem',
        'x-component': 'VerifyCode',
        'x-component-props': {
          allowPostCode: () => !isPreview,
        },
        'x-reactions': [
          {
            dependencies: ['.phone#value', '.phone#valid'],
            fulfill: {
              state: {
                'component[1].readyPost': '{{$deps[0] && $deps[1]}}',
                'component[1].phoneNumber': '{{$deps[0]}}',
              },
            },
          },
        ],
      },
    },
  }
  return phoneSchema
}

/**
 * 密码登录表单
 *
 * @returns 表单字段
 */
export const usePasswordSchema = () => {
  const schema = {
    type: 'object',
    properties: {
      password: {
        type: 'string',
        required: true,
        'x-decorator': 'FormItem',
        'x-component': 'Password',
        'x-decorator-props': {
          style: { marginBottom: 24 },
        },
        'x-component-props': {
          placeholder: '设置新密码，密码长度6-20位',
        },
        'x-validator': (value: string) => {
          const reg = /^[A-Za-z0-9_-]{6,20}$/
          if (!reg.test(value)) {
            return {
              type: 'error',
              message: '只允许字母、数字、下划线"_"或中划线"-",要求6-20位',
            }
          }
        },
      },
      repeatPassword: {
        type: 'string',
        required: true,
        'x-decorator': 'FormItem',
        'x-component': 'Password',
        'x-component-props': {
          placeholder: '设置新密码，密码长度6-20位',
        },
        'x-validator'(value: string, data: any, context: any) {
          const password = context.form.getFormState().values.password
          if (value !== password) {
            return {
              type: 'error',
              message: '两次输入的密码不一致!',
            }
          }
        },
      },
    },
  }
  return schema
}
